import * as actionTypes from './actions';
import ls from 'local-storage';

const initialState = {
    mode: 'general',
    current_question_index: 0,
    question_answers: [],
    show_response: false,
    response_text: '',
    intro: true,
    version: 'v1',
    quote_saved: false,
    quote_id: 0,
    quote_hash: '',
};

const resetResponse = ( newState ) => {
    newState.show_response = false;
    newState.response_text = '';

    return newState;
};

const setInitialStateFromLocalStorage = ( newState ) => {

    const introState = ls.get( newState.mode + '_intro' );

    if( introState === 'true' || introState === null ) {
        newState.intro = true;
    } else {
        newState.intro = false;
    }

    newState.version = ls.get( newState.mode + '_version' ) || 'v1';
    newState.current_question_index = ls.get( newState.mode + '_current_question_index' ) || 0;
    newState.question_answers = ls.get( newState.mode + '_question_answers' ) || [];
    newState.quote_saved = ls.get( newState.mode + '_quote_saved' ) || false;
    newState.quote_id = ls.get( newState.mode + '_quote_id' ) || 0;
    newState.quote_hash = ls.get( newState.mode + '_quote_hash' ) || '';

    return newState;

};

const updateLocalStorage = ( newState ) => {

    ls.set( newState.mode + '_intro', newState.intro ? 'true' : 'false' );
    ls.set( newState.mode + '_version', newState.version );
    ls.set( newState.mode + '_current_question_index', newState.current_question_index );
    ls.set( newState.mode + '_question_answers', newState.question_answers );
    ls.set( newState.mode + '_quote_saved', newState.quote_saved );
    ls.set( newState.mode + '_quote_id', newState.quote_id );
    ls.set( newState.mode + '_quote_hash', newState.quote_hash );

};

const reducer = ( state = initialState, action ) => {

    let newState = {
        ...state
    };

    switch( action.type ) {
        case actionTypes.SET_INITIAL_STATE_LOCAL_STORAGE:

            newState = setInitialStateFromLocalStorage( newState );

            return newState;

        case actionTypes.START_SURVEY:

            newState.intro = false;

            updateLocalStorage( newState );

            return newState;

        case actionTypes.CHOOSE_ANSWER:

            const QuestionsData = require( '../data/' + newState.mode + '-questions.js' );

            if( newState.question_answers[ newState.current_question_index ] === action.answerIndex ) {
                newState.current_question_index++;

                return newState;
            }

            newState.question_answers[ newState.current_question_index ] = action.answerIndex;
            newState.show_response = true;
            newState.response_text = QuestionsData[ newState.version ][ newState.current_question_index ].answers[ action.answerIndex ].response;

            updateLocalStorage( newState );

            return newState;

        case actionTypes.NEXT_QUESTION:

            newState.current_question_index++;

            newState = resetResponse( newState );

            updateLocalStorage( newState );

            return newState;

        case actionTypes.GO_BACK:

            if( newState.show_response ) {
                newState = resetResponse( newState );

                return newState;
            }

            newState.current_question_index--;

            updateLocalStorage( newState );

            return newState;

        case actionTypes.GO_TO_QUESTION:

            newState.current_question_index = action.questionIndex;

            newState = resetResponse( newState );

            updateLocalStorage( newState );

            return newState;

        case actionTypes.PREVIOUS_QUESTION:

            if( newState.current_question_index > 0 ) {
                newState.current_question_index--;
            }

            newState = resetResponse( newState );

            updateLocalStorage( newState );

            return newState;

        case actionTypes.SET_INITIAL_STATE:
            newState = getQuoteFromHash( action.result_data, newState );

            updateLocalStorage( newState );

            return newState;

        case actionTypes.QUOTE_SAVED:

            newState.quote_saved = true;
            newState.quote_id = action.quote_id;
            newState.quote_hash = action.quote_hash;

            updateLocalStorage( newState );

            return newState;

        case actionTypes.RESET_QUOTE:

            let initialMode = newState.mode;

            newState = initialState;

            newState.mode = initialMode;

            return newState;

        case actionTypes.SET_MODE:

            newState.mode = action.mode;

            return newState;

        default:
            return state;
    }

};

const getQuoteFromHash = ( result_data, newState ) => {

    const survey_data = JSON.parse( result_data.data.survey_data );

    newState.intro   = false;
    newState.version = result_data.data.version;

    newState.current_question_index = survey_data.length;
    newState.question_answers       = survey_data;

    return newState;

};

export default reducer;
